import Service from './Service';

let _blur = false;
let _disableScroll = false;
let _contentFullscreen = false;

class AppRoot extends Service {

  get blur() {
    return _blur;
  }
  set blur(value) {
    if (_blur === value) return;
    _blur = value;
    this.emitStateUpdate();
  }
  get disableScroll() {
    return _disableScroll;
  }
  set disableScroll(value) {
    if (value === _disableScroll) return;
    _disableScroll = value;
    this.emitStateUpdate();
  }
  get contentFullscreen() {
    return _contentFullscreen;
  }
  set contentFullscreen(value) {
    if (value === _contentFullscreen) return;
    _contentFullscreen = value;
    this.emitStateUpdate();
  }
}
const singleton = new AppRoot();
export default singleton;
